<!-- 招生系统基础配置 -- 中考普高控制线 -- 列表 -->
<template>
  <div>
    <list-template
        :loading="loading"
        :search-config="searchConfig"
        @onSearch="onSearch"
        :table-config="tableConfig"
        :table-data="tableData"
        :total="total"
        @onAdd="$router.push('./add')"
        has-add
        :current-page="page"
        @onChangePage="handleCurrentChange"
        @onHandle="handleEdit"
    ></list-template>
    <!-- 历史记录 -->
    <h-dialog :historyDialogShow="historyDialogShow" :historyList="historyList" @close="historyDialogShow = false"></h-dialog>
  </div>
</template>

<script>
//引入ajax接口管理层的接口函数
import {mapState} from "vuex";

export default {
	_config:{"route":{"path":"list","meta":{"title":"列表","keepAlive":true}}},
  data() {
    return {
      loading:true,
      search: {},
      searchConfig: [
        {
          prop: "city",
          tag: 'input',
          placeholder: "搜索城市名称",
        },
      ],
      tableData: [],
      //总条数
      total: 0,
      pageCount: 0,

      tableConfig: [
        {prop: "province", label: "省份"},
        {prop: "city", label: "城市"},
        {prop: "year", label: "年份"},
        {prop: "creator", label: "创建人"},
        {
          prop: "handle",
          label: "操作",
          width: "180rem",
          handle: true,
          render(row) {
            return ["编辑", "查看历史记录"]
          }
        },
      ],

      historyDialogShow: false,
      historyList: []
    }
  },
  created() {
    this.$store.commit("setPage", 1);
    this.getData()
  },
  activated() {
    this.getData()
  },
  computed: {
    ...mapState(["page"])
  },
  beforeRouteLeave(to, from, next) {
    // from.meta.keepAlive = true;
    next();
  },
  methods: {
    getData() {
      let params = {...this.search, page: this.page};
      this.loading = true;
      this.$_register('/api/recruit/score-line', {params}).then(res => {
        let data = res.data.data
        this.tableData = data.list
        this.total = data.page.total
      }).finally(()=>this.loading = false);
    },

    onSearch(val) {
      this.$store.commit('setPage', 1);
      this.search = val;
      this.getData(val)
    },

    handleEdit(row, text) {
      if (text.type === 'edit') {
        this.$router.push('./edit?id=' + row.id)
      }

      if (text.type === 'viewHistory') {
        let params = {
          tbl_name: 'score_line',
          tbl_id: row.id
        }
        this.$_register.get('/api/recruit/common/get-opt-history',{params}).then(res => {
          let data = res.data.data
          this.historyList = data.list.length ? data.list : []
          this.historyDialogShow = true;
        })
      }
    },

    // 当前页改变触发
    handleCurrentChange(val) {
      //当前页赋值给currentPage
      this.$store.commit("setPage", val);
      //拉取数据
      this.getData()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .t-search-block .el-input {
  width: auto !important;
}

.role-list {
  padding-top: 24rem;
}

.button {
  margin-left: 34rem;
  margin-bottom: 30rem;
  box-sizing: border-box;
  width: 90rem;
  height: 34rem;
  opacity: 1;
  border-radius: 4rem;
}

.table {
  margin-left: 32rem;
}



::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell {
  text-align: left;
  font-size: 14rem;
  font-family: Microsoft YaHei;
  font-weight: normal;
  height: 48rem;
  box-sizing: border-box;
  color: #333333;
}

.header {
  position: fixed;
  top: 120rem;
  left: 300rem;
  font-size: 16rem;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 24rem;
  color: #333333;
  letter-spacing: 3.5rem;
}

.el-button--text {
  margin-right: 40rem;
  font-size: 14rem;
  font-family: Microsoft YaHei;
  font-weight: normal;
  color: #3491fa;
}
</style>
